"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get formatDuration () {
        return formatDuration;
    },
    get hrToSeconds () {
        return hrToSeconds;
    },
    get hrtimeDiff () {
        return hrtimeDiff;
    }
});
function formatDuration(seconds) {
    const raw = parseFloat(seconds);
    if (raw > 60) {
        const minutes = Math.floor(raw / 60);
        const seconds = (raw - minutes * 60).toFixed(2);
        return `${minutes}m ${seconds}s`;
    } else {
        const seconds = raw.toFixed(2);
        return `${seconds}s`;
    }
}
function hrToSeconds(hrtime) {
    const raw = hrtime[0] + hrtime[1] / 1e9;
    return raw.toFixed(2);
}
function hrtimeDiff(start = [
    0,
    0
], end = [
    0,
    0
]) {
    const sec = end[0] - start[0];
    const nsec = end[1] - start[1];
    if (nsec < 0) {
        return [
            Math.max(0, sec - 1),
            1e9 + nsec
        ];
    }
    return [
        sec,
        nsec
    ];
}
